import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";

const CustomBreadcrumb = ({ menus }) => {
  function itemRender(route, params, menus, paths) {
    const last = menus.indexOf(route) === menus.length - 1;
    return last ? (
      <span>
        {route.icon ?? false}
        {route.icon && " "}
        {route.breadcrumbName}
      </span>
    ) : (
      <Link className="ant-breadcrumb-link" to={route.path}>
        {route.icon ?? false}
        {route.icon && " "}
        {route.breadcrumbName}
      </Link>
    );
  }

  return (
    <div style={{ paddingBottom: 10 }}>
      <Breadcrumb itemRender={itemRender} items={menus} />
    </div>
  );
};

export default CustomBreadcrumb;
